import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import type { Precificacao } from '@/types/agentesIa';

interface PrecificacaoResponse {
  success: boolean;
  data: Precificacao | null;
}

export function usePrecificacaoResultado(
  empresaId: number | undefined,
  licitacaoId: number | undefined,
  refreshKey?: string
) {
  return useQuery<Precificacao | null>({
    queryKey: ['central-planilhas-resultado', empresaId, licitacaoId, refreshKey],
    queryFn: async () => {
      const response = await api.get<PrecificacaoResponse>(
        `/empresas/${empresaId}/central-planilhas`,
        { params: { licitacaoId } }
      );
      return response.data;
    },
    enabled: Boolean(empresaId && licitacaoId),
  });
}
